import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

// модули
import { SpinnersModule } from '../core/components/spinners/spinners.module';
import { CoreModule } from '../core/core.module';

// страницы
import { ContentSlugRedirectPageComponent } from './content-slug-redirect-page/content-slug-redirect-page.component';

/**
 * Этот роут срабатывает после ленивой загрузки модуля по роуту /go/library/:user/:slug
 *
 * @see AppRoutingModule
 */
const routes: Routes = [
  {
    path: '',
    component: ContentSlugRedirectPageComponent,
  },
];

@NgModule({
  imports: [LocaleSharedModule, CommonModule, RouterModule.forChild(routes), CoreModule, SpinnersModule],
  declarations: [ContentSlugRedirectPageComponent],
  providers: [],
  exports: [],
})
export class ContentSlugRedirectRoutingModule {}
